import React, { useState, useEffect } from 'react'
import Helper from '../../../helper/Helper';
import { useTranslation } from 'react-i18next';
import { PAYMENT_MODE } from '../../../data/constant';
import { GET_PAYMENT_NUMBER } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import Alert from '../../../feature/Alert';


export default function NewPayment(props) {

     const { onClick } = props;

     const { t } = useTranslation();

     const [paymentDetails, setPaymentDetails] = useState({ prefix: '', number: '', payment_date: Helper.getToday(), mode: '', amount: 0, reference: '', charges: 0 });

     useEffect(() => {
          getPaymentNumber();
     }, [])

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const payment = { ...paymentDetails };
          payment[fieldName] = value;
          setPaymentDetails(payment);
     };

     const getPaymentNumber = async (e) => {
          const res = await httpClient.post(GET_PAYMENT_NUMBER, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setPaymentDetails(prevPaymentDetails => ({
                         ...prevPaymentDetails,
                         prefix: result.prefix,
                         number: result.payment_number
                    }));
               }
          }
     }

     const sendPayment = () => {
          if (paymentDetails.amount !== '' && paymentDetails.amount > 0) {
               onClick(paymentDetails);
          }else{
               Alert.error("Please Enter Amount");
          }          
     }

     return (
          <div className='p-2 pb-2  bg-light'>              
               <div>
                    <div className='row '>
                         <div className='col-md-3 '>
                              <label className='small' htmlFor='prefix'>{t('number')}</label>
                              <div className='input-group'>
                                   <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                        <input id='prefix' value={paymentDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                   </div>
                                   <input id='number' value={paymentDetails.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                              </div>
                         </div>
                         <div className='col-md-2 '>
                              <label className='small' htmlFor='payment_date'>{t('date')}</label>
                              <input id='payment_date' value={paymentDetails.payment_date} type='date' name='payment_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('payment_date', e)} />
                         </div>
                         <div className='col-md-2 '>
                              <label className='small' htmlFor='amount'>{t('amount')}</label>
                              <input id='amount' value={paymentDetails.amount} type='number' name='amount' className='form-control form-control-sm' onBlur={sendPayment}  onChange={(e) => handleInputChange('amount', e)} />
                         </div>
                         <div className='col-md-2 '>
                              <label className='small' htmlFor='reference'>{t('reference')}</label>
                              <input id='reference' value={paymentDetails.reference} type='text' name='reference' className='form-control form-control-sm' onChange={(e) => handleInputChange('reference', e)} />
                         </div>
                         <div className='col-md-1 '>
                              <label className='small' htmlFor='charges'>{t('charges')}</label>
                              <input id='charges' value={paymentDetails.charges} type='number' name='charges' className='form-control form-control-sm' onChange={(e) => handleInputChange('charges', e)} />
                         </div>
                         <div className='col-md-2 '>
                              <label className='small' htmlFor='mode'>{t('mode')}</label>
                              <select id='mode' name='mode' className='form-control form-control-sm' onChange={(e) => handleInputChange('mode', e)}>
                                   <option value=''>Select</option>
                                   {Object.entries(PAYMENT_MODE).map(([key, value]) => (
                                        <option key={key} value={key}>
                                             {value}
                                        </option>
                                   ))}
                              </select>
                         </div>
                         <div className='col-md-2'>                            
                              <button onClick={sendPayment} style={{marginTop:"24px"}} className='btn btn-sm btn-danger auto_click'>{t('save_payment')}</button>
                         </div>
                    </div>
               </div>
          </div>

     )
}
